<!-- 
Notices for a levy collection.
-->
<template>
  <div>
    <our-heading 
      :breadcrumbs="getBreadcrumbs('notices')"
      :subtitle="statusDescription"
      title="Notices"
      subtitle-tooltip="Levy collection status"
      user-guide-topic="levy-collection-notices"
    >
      <template v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" />
      </template>
    </our-heading>
    <our-search-bar v-if="hasNotices">
      <our-quick-search 
        slot="quick-search"
        :criteria-mutation="criteriaMutation" 
        :value="quickSearch"
        label="Provider name or code" 
        field="providerName" 
        field-if-numeric="providerCode" 
        @changed="$refs.notices.refresh()"
      />
      <our-search-button 
        slot="search-button"
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters" 
        title="Search notices"
        show-all
        @changed="$refs.notices.refresh()"
      />
      <our-saved-searches-menu
        slot="saved-searches-button"
        :criteria="criteria"
        :criteria-mutation="criteriaMutation"
        :clear-criteria-mutation="clearCriteriaMutation"
        module="notices" 
        @selected="$refs.notices.refresh()"
      />
    </our-search-bar>
    <notice-listing
      v-show="hasNotices" 
      ref="notices" 
      :levy-collection-id="levyCollectionId" 
    />
    <our-getting-started-hint v-if="!hasNotices">
      <p>
        Notices are emails sent by the LTPS system to providers. 
        You can review and edit the template for a notice before sending it on the levy collection <i>Setup Notices</i> page.
      </p>
      <p class="text-xs-right">
        <v-btn flat color="primary" @click="openNoticeTemplates">Go to setup notices</v-btn>
      </p>
      <p v-if="isPreparing" class="mb-0">
        No notices have been sent yet. 
        Go to <i>Workflow</i> and run the <i>Start communicating</i>
        task to start sending notices.
      </p>
      <p v-else class="mb-0">
        Notices will start appearing here once the <i>Send early advice notice</i> task is run.
        Go to <i>Workflow</i> if you want to run the task.
      </p>
      <p class="text-xs-right">
        <v-btn :to="`/levy-collections/${levyCollectionId}/workflow`" flat color="primary">Go to workflow</v-btn>
      </p>
    </our-getting-started-hint>
  </div>
</template>

<script>
import NoticeListing from "@/components/notices/NoticeListing.vue";
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import levyCollectionMixins from "./mixins";
import * as mutation from "@/store/notices/mutation-types";
import { getSearchFilters } from "@/store/notices/helpers";

export default {
  components: {
    LevyCollectionNavigator,
    NoticeListing
  },
  mixins: [levyCollectionMixins],
  data() {
    return {
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA,
      redirectIfSandbox: true
    };
  },
  computed: {
    criteria() {
      return this.$store.state.notices.listing.criteria;
    },
    searchFilters() {
      return getSearchFilters();
    },
    hasNotices() {
      return !this.$store.state.notices.listing.empty;
    },
    isPreparing() {
      return this.levyCollection.status == "Preparing";
    },
    quickSearch() {
      return this.criteria.providerCode && !this.criteria.providerName
        ? this.criteria.providerCode
        : this.criteria.providerName;
    }
  },
  methods: {
    openNoticeTemplates() {
      this.$router.push(`/levy-collections/${this.levyCollectionId}/setup/notices`);
    }
  }
};
</script>
